import React from "react";
import {
  TabContent,
  TabPane,
  Card,
  CardBody,
  Row,
  Col,
} from "reactstrap";
import classnames from "classnames";
import RevenueAnalyticsRoomBooking from "./RevenueAnalyticsRoomBooking";
import RevenueAnalyticsFoodOrder from "./RevenueAnalyticsFoodOrder";
import RevenueAnalyticsTableBooking from "./RevenueAnalyticsTableBooking";
import RevenueAnalyticsTransport from "./RevenueAnalyticsTransport";

export default class RevenueTab extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: "1",
    };
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  render() {
    const tabs = [
      { id: "1", label: "Room Bookings", icon: "ri-hotel-bed-line", color: "#5664d2" },
      { id: "2", label: "Food Orders", icon: "ri-restaurant-line", color: "#1cbb8c" },
      { id: "3", label: "Table Bookings", icon: "ri-table-line", color: "#f1b44c" },
      { id: "4", label: "Transport", icon: "ri-taxi-line", color: "#ff6b6b" },
    ];

    return (
      <Card className="revenue-tab-card">
        <CardBody className="p-0">
          {/* Modern Tab Navigation */}
          <div className="revenue-tabs-wrapper">
            <div className="revenue-tabs">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  className={classnames("revenue-tab", { active: this.state.activeTab === tab.id })}
                  onClick={() => this.toggle(tab.id)}
                  style={{
                    "--tab-color": tab.color,
                  }}
                >
                  <i className={`${tab.icon} tab-icon`}></i>
                  <span className="tab-label">{tab.label}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Tab Content */}
          <TabContent activeTab={this.state.activeTab} className="p-0">
            <TabPane tabId="1">
              <RevenueAnalyticsRoomBooking />
            </TabPane>

            <TabPane tabId="2">
              <RevenueAnalyticsFoodOrder />
            </TabPane>

            <TabPane tabId="3">
              <RevenueAnalyticsTableBooking />
            </TabPane>

            <TabPane tabId="4">
              <RevenueAnalyticsTransport />
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>
    );
  }
}
